import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import { IonContent, NavController, ModalController} from '@ionic/angular';

import { UserService } from '../../../services/user.service';
import { StripeService } from '../../../services/stripe.service';
import { RegisterCardReaderComponent } from './register-card-reader/register-card-reader.component';

@Component({
  selector: 'smr-connect-card-reader',
  templateUrl: './connect-card-reader.page.html',
  styleUrls: ['./connect-card-reader.page.scss'],
})
export class ConnectCardReaderPage implements OnInit {

  @ViewChild(IonContent) content: IonContent;

  public isLoading: boolean;

  public existingTerminal: boolean = false;

  public searchingForCardReader: boolean = false;

  public createdStripeAccount: boolean = false;

  public errorOccurredWhileLoadingStats: boolean = false;

  public connectPushed: Array<boolean> = [];

  public disconnectPush: Array<boolean> = [];

  public cardReaderConnectError: Array<boolean> = [];

  public readerConnectSuccessful: Array<boolean> = [];

  public readerDisconnectSuccessful: Array<boolean> = [];

  public readers: Array<any> = [];

  constructor(
    private navCtrl: NavController,
    private userService: UserService,
    private modalCtrl: ModalController,
    private stripeService: StripeService,
    private ref: ChangeDetectorRef
  ) {
    this.isLoading = true;
  }

  public async discoverReaders (connect: boolean) {
    this.disconnectPush = [];
    this.connectPushed = [];
    this.readerDisconnectSuccessful = [];
    this.readerConnectSuccessful = [];
    this.cardReaderConnectError = [];

    this.searchingForCardReader = true;
    const res = await this.stripeService.discoverReaders();
    if (res.code === "reader_not_found" || res.code === "reader_error") {
      this.existingTerminal = false;
      this.readers = [];
    } else {
      this.readers = await Promise.all(res.discoveredReaders.map( async reader => {
        this.disconnectPush.push(false);
        this.connectPushed.push(false);
        this.readerDisconnectSuccessful.push(false);
        this.readerConnectSuccessful.push(false);
        this.cardReaderConnectError.push(false);
        return {reader, status: await this.readerStatus(reader)}
      }));
      this.existingTerminal = true;
    }
    this.searchingForCardReader = false;
    if (connect) {
      await this.connectCardReader(res.discoveredReaders[0], 0);
    }
    this.ref.detectChanges();
  }

  public async connectCardReader (reader, i) {
    this.connectPushed[i] = true;
    this.cardReaderConnectError[i] = false;
    const connectResponse = await this.stripeService.connectReader(reader);
    if (connectResponse["error"]) {
      this.cardReaderConnectError[i] = true;
      this.connectPushed[i] = false;
      this.ref.detectChanges();
    } else {
      this.readerConnectSuccessful[i] = true;
      this.ref.detectChanges();
    }
  }

  public async readerStatus (reader) {
    return await this.stripeService.getStatus(reader) === "connected";
  }

  public async ngOnInit () {
    await this.discoverReaders(false);
    this.isLoading = false;
    this.ref.detectChanges();
  }

  public async onRegisterCardReader () {

    const registerCardReaderModal = await this.modalCtrl.create({
      component: RegisterCardReaderComponent
    })
      
    registerCardReaderModal.present();

    registerCardReaderModal.onDidDismiss().then(async (data)=> {
      if (data.data) {
       await this.discoverReaders(true);
      }
      this.existingTerminal = data.data.cardReaderConnected || (this.readers.length > 0);
    });
  }

  public async disconnectReader (reader, i) {
    this.disconnectPush[i] = true;
    await this.stripeService.disconnectReader(reader);
    this.readerDisconnectSuccessful[i] = true;
    this.ref.detectChanges();
  }


  public onTapToReload () {
    this.isLoading = true;
    this.ngOnInit();
  }
}
